import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShow(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setShow(false);
    // Disable GA if rejected
    (window as any)['ga-disable-G-CN4X3K45MJ'] = true;
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 bg-card border rounded-lg shadow-lg p-4">
      <button
        onClick={rejectCookies}
        className="absolute top-2 right-2 text-muted-foreground hover:text-foreground"
        aria-label="Close"
      >
        <X className="h-4 w-4" />
      </button>
      <h3 className="font-semibold mb-2">Cookie Notice</h3>
      <p className="text-sm text-muted-foreground mb-4">
        We use cookies to analyze site traffic and improve your experience. 
        We are GDPR-compliant and do not sell your data.
      </p>
      <div className="flex gap-2">
        <Button size="sm" onClick={acceptCookies}>
          Accept
        </Button>
        <Button size="sm" variant="outline" onClick={rejectCookies}>
          Reject
        </Button>
      </div>
    </div>
  );
};
